import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LoginPage } from "./admin/LoginPage";
import { Dashboard as ClientsPage } from "./admin/Dashboard";
import { Layout } from "./admin/Layout";
import { OverviewPage } from "./admin/OverviewPage";
import "./index.css";
import "./admin/admin.css";

export function App() {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(null);

  useEffect(() => {
    const token = localStorage.getItem("admin_token");
    setIsLoggedIn(!!token);
  }, []);

  const handleLogin = (token: string) => {
    localStorage.setItem("admin_token", token);
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    localStorage.removeItem("admin_token");
    setIsLoggedIn(false);
  };

  if (isLoggedIn === null) return null;

  if (!isLoggedIn) {
    return (
      <div className="min-h-screen font-sans selection:bg-purple-500/30">
        <LoginPage onLogin={handleLogin} />
      </div>
    );
  }

  return (
    <BrowserRouter>
      <div className="min-h-screen font-sans selection:bg-purple-500/30">
        <Routes>
          <Route element={<Layout onLogout={handleLogout} />}>
            <Route path="/" element={<OverviewPage />} />
            <Route path="/clients" element={<ClientsPage onLogout={() => {}} />} />
            {/* Catch-all redirect to overview */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
